import { IHelperTextProp } from 'types/tooltips';
import { Translate } from 'types/common';
import { DynamicValues } from '../constants/dynamicValues';

export const getEditorTextLinkDynamicValueHelperProps = (
	tr: Translate
): IHelperTextProp => ({
	meta: {
		example: tr('screenEditor.settings.dynamic.values.helper.text'),
		trigger: tr('button.usingDynamicValues')
	},
	content: {
		header: tr('screenEditor.settings.dynamic.values.helper.tooltip.1'),
		footer: tr('screenEditor.settings.dynamic.values.helper.tooltip.4')
	},
	children: [
		{
			title: intl.tr('screenEditor.settings.dynamic.values.helper.tooltip.2'),
			children: [
				DynamicValues.user.NAME,
				DynamicValues.user.EMAIL,
				DynamicValues.user.PHONE,
				DynamicValues.user.ID,
				DynamicValues.sentTo.EMAIL,
				DynamicValues.sentTo.PHONE
			]
		},
		{
			title: tr('screenEditor.settings.dynamic.values.helper.tooltip.3'),
			children: [
				DynamicValues.input.EMAIL,
				DynamicValues.input.PHONE,
				DynamicValues.input.EXTERNAL_ID
			]
		}
	]
});
